import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the AmpolCashOrderDetailsModal component.
 * Consolidates 12 individual useSelector calls into one, reducing re-renders
 * by only recalculating when userStore, cashStore, or activateMultipleCards change.
 */
export const selectAmpolCashOrderDetailsContext = createSelector(
  [
    (state: RootState) => state.userStore,
    (state: RootState) => state.cashStore,
    (state: RootState) => state.activateMultipleCards,
  ],
  (userStore, cashStore, activateMultipleCards) => ({
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    cashOrderDetailsLoading: cashStore.cashOrderDetailsLoading,
    cashOrderDetailsError: cashStore.cashOrderDetailsError,
    cashOrderDetails: cashStore.cashOrderDetails,
    cashOrderCardDetailsPageNumber: cashStore.cashOrderCardDetailsPageNumber,
    currentCashOrderCardDetailsPageNumber: cashStore.currentCashOrderCardDetailsPageNumber,
    activateCardIsLoading: activateMultipleCards.isLoading,
    activateCardError: activateMultipleCards.isError,
    activateCardSuccess: activateMultipleCards.activateCardSuccess,
  })
);
